module.exports = __webpack_public_path__ + "img/bgc3.78a6da30.jpg";